import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, TextField, Button } from "@kuda/ui";

const NAME_REGEX = /^[A-Za-z][A-Za-z0-9_-]*$/;

const RenameSecretDialog = ({ open, onClose, currentName, onConfirm, loading }) => {
  // currentName may be a full Vault path (dev/kuda-internaltools/foo) — only
  // the leaf segment is ever user-editable/regex-validated; the folder
  // prefix (unrelated to renaming) is preserved and re-attached on confirm.
  const lastSlash      = (currentName || "").lastIndexOf("/");
  const folderPrefix   = lastSlash === -1 ? "" : currentName.slice(0, lastSlash + 1);
  const currentLeaf    = lastSlash === -1 ? (currentName || "") : currentName.slice(lastSlash + 1);

  const [name, setName] = useState(currentLeaf);
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setName(currentLeaf);
      setError("");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, currentName]);

  const handleChange = (e) => {
    const value = e.target.value;
    setName(value);
    if (value && !NAME_REGEX.test(value)) {
      setError("Must start with a letter, you can also add [0-9, -,_]");
    } else {
      setError("");
    }
  };

  const handleConfirm = () => {
    if (!name || error || name === currentLeaf) return;
    onConfirm(folderPrefix + name);
  };

  return (
    <Dialog open={open} onOpenChange={(next) => { if (!next) onClose(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Rename secret</DialogTitle>
        </DialogHeader>
        <TextField
          label="New name"
          value={name}
          onChange={handleChange}
          error={!!error}
          helperText={error || `Renaming "${currentLeaf}" creates a new secret and deletes the old one.`}
        />
        <DialogFooter>
          <Button variant="text" onClick={onClose} disabled={loading}>Cancel</Button>
          <Button
            variant="filled"
            onClick={handleConfirm}
            disabled={!name || !!error || name === currentLeaf}
            loading={loading}
          >
            Rename
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default RenameSecretDialog;
